import React from "react";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";
import Applications from "./Applications";
import Settings from "./Settings";
import Migrate from "./Migrate";
import { QueryClient, QueryClientProvider } from "react-query";

export default function App({ workspace, locale }) {
  const basePath = "/default/dashboard"; // i dont think this base url should have 'jp' in it. It breaks everything ! #confusing.
  const queryClient = new QueryClient();
  return (
    <div id="react-app" className="container mx-auto">
      <Router basename={basePath}>
        <QueryClientProvider client={queryClient}>
          <Switch>
            <Route exact path="/">
              <Applications workspace={workspace} locale={locale} />
            </Route>
            <Route path="/applications">
              <Applications workspace={workspace} locale={locale} />
            </Route>
            <Route path="/settings">
              <Settings workspace={workspace} locale={locale} />
            </Route>
          </Switch>
        </QueryClientProvider>
      </Router>
    </div>
  );
}
